import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../widgets/tables/Table';
import WaitDialog from '../../widgets/WaitDialog';
import { NineCellLoading } from 'react-loadingg';

import getNotificheWeb from '../../services/getNotificheWeb';
import checkUtente from "../../services/checkUtente";
import NotificaWidget from "../../widgets/NotificaWidget";
import getInsegnanti from '../../services/getInsegnanti';
import AdWidget from "../../widgets/AdWidget";
import translateString from "../../utils/Locales";

let t = translateString;

export default class NotificheTeacher extends React.Component {

  constructor(props){
    super (props)

    this.state = {
      waitDialogVisible: false,
      isLoading: true,
    }

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.utente = await checkUtente(username, token, username);
    this.insegnanti = await getInsegnanti(username, token);
    this.currUtente = this.insegnanti.filter((insegnante) => insegnante.id === this.utente[0].user_id)[0];
    
    this.notifiche = await getNotificheWeb(username, token);
    this.notifiche = this.notifiche.filter((notifica) => notifica.subjectId === this.currUtente.id);
    this.notifiche.forEach((notifica) => {
      notifica.body = notifica.body.replace(/\\n/g, '');
      notifica.bodyFull = notifica.bodyFull.replace(/\\n/g, '');
      if (notifica.corso != null) {
        notifica.name = notifica.corso;
      } else if (notifica.studente != null) {
        notifica.name = notifica.studente;
      }
    })
    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();
  }

  render () {

    var headCells = [
      { id: 'date', numeric: false, disablePadding: true, label: t('data') },
      { id: 'name', numeric: false, disablePadding: true, label: t('nome') },
      { id: 'title', numeric: false, disablePadding: true, label: t('titolo') },
      { id: 'body', numeric: false, disablePadding: true, label: t('testo') },
    ];  

    this.searchCols = ['date', '_name', 'title', 'body'];
    
    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.notifiche == undefined) return <div />;
    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('tue_notifiche')} />
        <Table headCells={headCells} searchCols={this.searchCols} excel={false} calendar={false} mail={false} pdf={false} rows={this.notifiche}
          onEventClick={(id) => {
                var done = false;
                this.notifiche.forEach((notifica) => {
                    if (!done && notifica.id === id) {
                      this.setState({ showDetails: true, notifica: notifica });
                      done = true;
                    }
                });
          }}
        />
        { this.state.showDetails && (
          <NotificaWidget
            notifica={this.state.notifica}
            show={this.state.showDetails}
            onClose={ () => this.setState({ showDetails: false }) }
          />
        )}
        
        <AdWidget bottomWidget={true} />
        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </>
    );
  }
}

